<form
    class="vstack gap-3"
    appVenueColour
    [primaryColour]="venue.primaryColour"
    [formGroup]="detailsForm"
>
    <div class="vstack gap-2 flex-grow-0">
        <div class="hstack gap-3">
            <input
                id="inputFirstName"
                class="form-control"
                formControlName="firstName"
                type="text"
                autocapitalize="words"
                autocomplete="given-name"
                appCapitaliseOnBlur
                placeholder="First Name"
                data-testid="first-name"
                [ngClass]="{
                    'is-invalid': detailsForm.get('firstName')!!.invalid && detailsForm.get('firstName')!!.touched
                }"
            />
            <input
                id="inputLastName"
                class="form-control"
                formControlName="lastName"
                type="text"
                autocapitalize="words"
                autocomplete="family-name"
                appCapitaliseOnBlur
                placeholder="Surname"
                data-testid="last-name"
                [ngClass]="{
                    'is-invalid': detailsForm.get('lastName')!!.invalid && detailsForm.get('lastName')!!.touched
                }"
            />
        </div>
        <input
            id="inputEmailAddress"
            class="form-control"
            formControlName="emailAddress"
            type="text"
            autocomplete="email"
            placeholder="Email Address"
            data-testid="email-address"
            [ngClass]="{
                'is-invalid': detailsForm.get('emailAddress')!!.invalid && detailsForm.get('emailAddress')!!.touched
            }"
        />
        <div
            *ngIf="detailsForm.get('emailAddress')!!.hasError('serverValidation')"
            class="invalid-feedback d-block"
        >
            We couldn't quite verify this email address. Please double-check it for any typos, or perhaps try a different email address instead?
        </div>
        <ngx-intl-tel-input
            cssClass="form-control"
            [preferredCountries]="[phoneNumberCountryCode]"
            [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
            [selectFirstCountry]="false"
            [selectedCountryISO]="phoneNumberCountryCode"
            [separateDialCode]="false"
            [maxLength]="15"
            [numberFormat]="PhoneNumberFormat.International"
            [phoneValidation]="true"
            inputId="inputPhoneNumber"
            name="phone"
            formControlName="phoneNumber"
            data-testid="phone-number"
        >
        </ngx-intl-tel-input>

        <textarea
            class="form-control"
            placeholder="Booking Notes (optional)"
            id="inputNotes"
            formControlName="notes"
            data-testid="notes"
            style="height: 100px"
        >
        </textarea>
    </div>

    <div
        *ngIf="questions.controls.length > 0"
        class="vstack gap-2 flex-grow-0"
    >
        <ng-container formArrayName="questions">
            <ng-container
                *ngFor="let questionControl of questions.controls; let i = index"
                [formGroupName]="i"
            >
                <ng-container
                    *ngIf="questionControl.get('question')!!.value as question"
                >
                    <div
                        *ngIf="question.type === QuestionType.Checkbox"
                        class="form-check hstack gap-2 align-items-center"
                        data-testid="checkbox-question"
                    >
                        <input
                            class="form-check-input"
                            type="checkbox"
                            [id]="'question-' + i"
                            formControlName="answer"
                            [ngClass]="{
                                'is-invalid': questionControl.get('answer')!!.invalid && questionControl.get('answer')!!.touched
                            }"
                        >
                        <label
                            class="form-check-label"
                            [for]="'question-' + i"
                        >
                            {{ question.text }}
                            <span
                                *ngIf="questionControl.get('answer')!!.invalid && questionControl.get('answer')!!.touched"
                                class="text-danger"
                            >
                                (Required)
                            </span>
                        </label>
                    </div>
                    <div
                        *ngIf="question.type === QuestionType.Dropdown"
                        class="ms-4 ps-2 vstack gap-2 flex-grow-0"
                        data-testid="dropdown-question"
                    >
                        <label
                            for="question-{{ i }}"
                            class="form-label m-0"
                            [ngClass]="{
                                'text-danger': questionControl.get('answer')!!.invalid && questionControl.get('answer')!!.touched
                            }"
                        >
                            {{ question.text }}
                            @if (questionControl.get('answer')!!.invalid && questionControl.get('answer')!!.touched) {
                                <span class="text-danger">
                                    (Required)
                                </span>
                            }
                        </label>
                        <div
                            ngbDropdown
                        >
                            <button
                                class="btn btn-outline-secondary"
                                id="question-{{ i }}"
                                ngbDropdownToggle
                                [ngClass]="{
                                    'is-invalid': questionControl.get('answer')!!.invalid && questionControl.get('answer')!!.touched
                                }"
                            >
                                <span
                                    *ngIf="!questionControl.get('answer')!!.value && !question.required"
                                >
                                    No Selection
                                </span>
                                <span
                                    *ngIf="!questionControl.get('answer')!!.value && question.required"
                                >
                                    Required
                                </span>
                                <span *ngIf="questionControl.get('answer')!!.value"
                                >
                                    {{ questionControl.get('answer')!!.value }}
                                </span>
                            </button>
                            <div ngbDropdownMenu>
                                <button
                                    *ngIf="!question.required"
                                    class="dropdown-item hstack gap-2 align-items-baseline justify-content-between"
                                    (click)="questionControl.get('answer')!!.setValue(null)"
                                >
                                    No Selection
                                    <i
                                        *ngIf="!questionControl.get('answer')!!.value"
                                        class="bi bi-check-circle"
                                    >
                                    </i>
                                </button>
                                <button
                                    *ngFor="let option of question.options"
                                    class="dropdown-item hstack gap-2 align-items-baseline justify-content-between"
                                    (click)="questionControl.get('answer')!!.setValue(option)"
                                >
                                    {{ option }}
                                    <i
                                        *ngIf="questionControl.get('answer')!!.value === option"
                                        class="bi bi-check-circle"
                                    >
                                    </i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="question.type === QuestionType.AcknowledgeEndTime"
                        class="form-check hstack gap-2 align-items-center"
                        data-testid="acknowledge-end-time"
                    >
                        <input
                            class="form-check-input"
                            type="checkbox"
                            [id]="'question-' + i"
                            formControlName="answer"
                            [ngClass]="{
                                'is-invalid': questionControl.get('answer')!!.invalid && questionControl.get('answer')!!.touched
                            }"
                        >
                        <label
                            class="form-check-label"
                            [for]="'question-' + i"
                        >
                            I acknowledge that my booking ends at
                            <span class="fw-bold">
                                {{ slotForm.get('endTime')!!.value | ngbTime | date: 'shortTime' }}
                            </span>
                            <span
                                *ngIf="questionControl.get('answer')!!.invalid && questionControl.get('answer')!!.touched"
                                class="text-danger"
                            >
                                (Required)
                            </span>
                        </label>
                    </div>
                    @if (question.type === QuestionType.DOB) {
                        <div
                            class="ms-4 ps-2 vstack gap-2 flex-grow-0"
                        >
                            <label
                                for="question-{{ i }}"
                                class="form-label m-0"
                            >
                                {{ question.text || 'When is your birthday?' }}
                                @if (!question.required) {
                                    (Optional)
                                }
                                @if (questionControl.get('answer')!!.invalid && questionControl.get('answer')!!.touched) {
                                    <span class="text-danger">
                                        @if (questionControl.get('answer')!!.errors; as errors) {
                                            @if (errors['dayRequired']) {
                                                (Select a day)
                                            } @else if (errors['invalidDate']) {
                                                (Invalid date)
                                            } @else {
                                                (Required)
                                            }
                                        }
                                    </span>
                                }
                            </label>
                            <app-day-of-year-input
                                class="me-sm-auto"
                                [formControlName]="'answer'"
                                [required]="question.required"
                            >
                            </app-day-of-year-input>
                        </div>
                    }
                    @if (question.type === QuestionType.DietaryRestrictions) {
                        <div
                            class="ms-4 ps-2 vstack gap-2 flex-grow-0"
                        >
                            <label
                                for="question-{{ i }}"
                                class="form-label m-0"
                                [ngClass]="{
                                    'text-danger': questionControl.get('answer')!!.invalid && questionControl.get('answer')!!.touched
                                }"
                            >
                                Dietary Restrictions
                                @if (!question.required) {
                                    (Optional)
                                } @else {
                                    (Required)
                                }
                            </label>
                            <div
                                ngbDropdown
                                container="body"
                                #dropdownMenu="ngbDropdown"
                                dropdownClass="dropdown-md-popup"
                                placement="top bottom end auto"
                            >
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary text-start"
                                    [attr.data-testid]="'question-' + i + '-button'"
                                    [id]="'question-' + i"
                                    ngbDropdownToggle
                                    [ngClass]="{
                                        'is-invalid': questionControl.get('answer')!!.invalid && questionControl.get('answer')!!.touched
                                    }"
                                >
                                @let isRequired = question.required;
                                @let answer = (questionControl.get('answer')!!.value | commaSplit);
                                <span class="text-truncate">
                                    @if (!answer.length && !isRequired) {
                                        No dietary restrictions
                                    } @else if (!answer.length && isRequired) {
                                        Let us know your dietary restrictions
                                    } @else {
                                        {{ answer.slice(0, 3).join(', ') }}
                                    }
                                </span>
                                    @if (answer.length > 3) {
                                        {{ ' + ' + (answer.length - 3) }} more
                                    }
                                </button>
                                <div ngbDropdownMenu class="border-0 p-0 shadow-lg">
                                    <app-multiple-choice-input
                                        [venue]="venue"
                                        [options]="question.dietaryRestrictionOptions"
                                        [title]="'Select dietary restrictions'"
                                        [formControl]="$any(questionControl.get('answer'))"
                                        (closeRequested)="dropdownMenu.close()"
                                    >
                                    </app-multiple-choice-input>
                                </div>
                            </div>
                        </div>
                    }
                    @if (question.type === QuestionType.DietaryRestrictionsText) {
                        <div
                            class="ms-4 ps-2 vstack gap-2 flex-grow-0"
                            data-testid="dietary-restrictions-text-question"
                        >
                            <label
                                for="question-{{ i }}"
                                class="form-label m-0"
                                [ngClass]="{
                                    'text-danger': questionControl.get('answer')!!.invalid && questionControl.get('answer')!!.touched
                                }"
                            >
                                Dietary Restrictions
                                @if (question.required) {
                                    (Required)
                                }
                            </label>
                            <input
                                class="form-control"
                                [id]="'question-' + i"
                                type="text"
                                [formControlName]="'answer'"
                                [ngClass]="{
                                    'is-invalid': questionControl.get('answer')!!.invalid && questionControl.get('answer')!!.touched
                                }"
                                [placeholder]="question.required ? 'Required' : 'Optional'"
                            >
                        </div>
                    }
                    <div
                        *ngIf="question.type === QuestionType.Text"
                        class="ms-4 ps-2 vstack gap-2 flex-grow-0"
                        data-testid="text-question"
                    >
                        <label
                            for="question-{{ i }}"
                            class="form-label m-0"
                            [ngClass]="{
                                'text-danger': questionControl.get('answer')!!.invalid && questionControl.get('answer')!!.touched
                            }"
                        >
                            {{ question.text }}
                            @if (question.required) {
                                (Required)
                            }
                        </label>
                        <input
                            class="form-control"
                            [id]="'question-' + i"
                            type="text"
                            [formControlName]="'answer'"
                            [ngClass]="{
                                'is-invalid': questionControl.get('answer')!!.invalid && questionControl.get('answer')!!.touched
                            }"
                            [placeholder]="question.required ? 'Required' : 'Optional'"
                        >
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>

    <div class="vstack gap-1 flex-grow-0">
        <div class="form-check hstack gap-2 align-items-center">
            <input
                class="form-check-input"
                type="checkbox"
                id="agreedToTerms"
                formControlName="agreedToTerms"
                data-testid="agreed-to-terms"
                [ngClass]="{
                    'is-invalid': detailsForm.get('agreedToTerms')!!.invalid && detailsForm.get('agreedToTerms')!!.touched
                }"
            >
            <label for="agreedToTerms">
                I have read and accept the TableSense
                <a class="text-body" [href]="privacyPolicyURL" target="_blank">Privacy Policy</a>
                agreement
                <span
                    *ngIf="detailsForm.get('agreedToTerms')!!.invalid && detailsForm.get('agreedToTerms')!!.touched"
                    class="text-danger small"
                >
                    You need to accept the Privacy Policy to continue with the booking
                </span>
            </label>
        </div>
        <div class="form-check hstack gap-2 align-items-center">
            <input
                class="form-check-input"
                type="checkbox"
                id="agreedToMarketing"
                formControlName="agreedToMarketing"
            >
            <label class="form-check-label" for="agreedToMarketing">
                I would like to receive news and offers from {{ venue.displayName }}
            </label>
        </div>
    </div>

    <div class="pb-3 pb-md-0 vstack justify-content-end">
        <hr class="m-0 mb-3 border-dark-subtle">
        <button
            *ngIf="detailsForm.get('paymentDetailsRequired')!!.value && !detailsForm.get('depositRequired')!!.value"
            type="button"
            class="btn btn-light border border-secondary-subtle"
            data-testid="confirm-details-next-payment-details"
            (click)="next()"
        >
            <div class="hstack gap-2 justify-content-center">
                Proceed to Card Details
                <img
                    src="assets/right/normal.svg"
                    alt="Arrow right"
                    class="icon"
                />
            </div>
        </button>
        <button
            *ngIf="!detailsForm.get('paymentDetailsRequired')!!.value && detailsForm.get('depositRequired')!!.value"
            type="button"
            class="btn btn-light border border-secondary-subtle"
            data-testid="confirm-details-next-deposit"
            (click)="next()"
        >
            <div class="hstack gap-2 justify-content-center">
                Proceed to Payment
                <img
                    src="assets/right/normal.svg"
                    alt="Arrow right"
                    class="icon"
                />
            </div>
        </button>
        <button
            *ngIf="!detailsForm.get('paymentDetailsRequired')!!.value && !detailsForm.get('depositRequired')!!.value"
            type="button"
            class="btn btn-primary"
            data-testid="confirm-details-book"
            (click)="book()"
        >
            Confirm & Book
        </button>
    </div>
</form>
